import { Box, Grid } from "@material-ui/core";
import FormBase from "../../../../forms/FormBase";
import ReRegistrationProfessionalPrivilegeForm, { ReRegistrationProfessionalPrivilegeFormItem } from "../../../../forms/recadastramento/ReRegistrationProfessionalPrivilegeForm";

import TmpTableBaseCustom, { ITableColumnsProps } from "../../../../components/tempo/TmpTableBaseCustom/TmpTableBaseCustom";
import TmpButtonCustom from "../../../../components/tempo/TmpButtonCustom/TmpButtonCustom";
import TmpInputSelectSearchAPICustom from "../../../../components/tempo/TmpInputSelectSearchAPICustom/TmpInputSelectSearchAPICustom";
import TmpInputCustom from "../../../../components/tempo/TmpInputCustom/TmpInputCustom";
import Privilege from "../../../../models/Privilege";
import OptionItemTyped from "../../../../models/OptionItemTyped";
import TmpTitleFormCustom from "../../../../components/tempo/TmpTitleFormCustom/TmpTitleFormCustom";
import { ReactComponent as IconCancelar } from "../../../../assets/icons/cancelar.svg";
import { ReactComponent as IconPesquisar } from "../../../../assets/icons/busca.svg";
import { useEffect, useState } from "react";
import { RetiraAcentos } from "../../../../helpers/Strings/NormalizeString";
import TooltipHtml from "../../../../components/controls/TooltipHtml";


interface ReRegistrationProfessionalPrivilegeComponentProps {
    ReRegistrationProfessionalPrivilegeForm: ReRegistrationProfessionalPrivilegeForm,
    onInputChange: (name: string, form: FormBase, value: any) => void
    onInserOrUpdateItem: () => void
    onEditClick: (e: ReRegistrationProfessionalPrivilegeFormItem) => void
    onDeleteClick: (e: ReRegistrationProfessionalPrivilegeFormItem) => void
    onCancelItem: () => void
}

export default function ReRegistrationProfessionalPrivilegeComponent(props: ReRegistrationProfessionalPrivilegeComponentProps) {

    const headers: ITableColumnsProps[] = [
        { title: "Titulo", align: "left", width: "25%", property: "Title", type: "text" },
        { title: "Privilégio", align: "left", property: "Privilege", type: "text" }
    ]

    const [filterPrivilegeText, setFilterPrivilegeText] = useState<string>("");
    const [filterControl, setFilterControl] = useState<boolean>(false);
    const [auxPrivilegeList, setAuxPrivilegeList] = useState<ReRegistrationProfessionalPrivilegeFormItem[]>([]);

    const handleSearchPrivilege = () => {

        var independentList = [...props.ReRegistrationProfessionalPrivilegeForm.FormItemList]

        if (filterPrivilegeText !== null && filterPrivilegeText !== undefined && filterPrivilegeText !== "" && independentList !== null) {
            let result = independentList.filter(v =>
                v.Privilege !== undefined && (
                    v.Privilege.toUpperCase().includes(filterPrivilegeText.toUpperCase()) || RetiraAcentos(v.Privilege).toUpperCase().includes(RetiraAcentos(filterPrivilegeText).toUpperCase()))
            );

            if (result !== undefined) {
                setAuxPrivilegeList(result);
            } else {
                setAuxPrivilegeList([ReRegistrationProfessionalPrivilegeFormItem.NewInstance()]);
            }
        } else {
            setAuxPrivilegeList(independentList);
        }
        setFilterControl(true);
    };

    const handleClearFilter = () => {
        var independentList = [...props.ReRegistrationProfessionalPrivilegeForm.FormItemList]
        setAuxPrivilegeList(independentList);
        setFilterControl(false);
        setFilterPrivilegeText("");
    };

    useEffect(() => {
        var independentList = [...props.ReRegistrationProfessionalPrivilegeForm.FormItemList]
        setAuxPrivilegeList(independentList);
    }, [props.ReRegistrationProfessionalPrivilegeForm.FormItemList])

    return (

        <Grid container spacing={3}>

            <Grid item xs={12}>
                {filterControl ?
                    <TmpTitleFormCustom marginTop={2}>
                        Seus Privilégios Cadastrados ({props.ReRegistrationProfessionalPrivilegeForm.FormItemList.length} Privilégios - {auxPrivilegeList.length} filtrados)
                    </TmpTitleFormCustom>
                    :
                    <TmpTitleFormCustom marginTop={2}>
                        Seus Privilégios Cadastrados ({props.ReRegistrationProfessionalPrivilegeForm.FormItemList.length} Privilégios)
                    </TmpTitleFormCustom>
                }
                <Grid container spacing={3}>

                    <Grid item xs={7} sm={7}>
                        <TmpInputCustom
                            id="PrivilegioFilter"
                            name="PrivilegioFilter"
                            label="Filtrar privilégios cadastrados"
                            maxLength={80}
                            type="text"
                            value={filterPrivilegeText}
                            placeholder="Informe o nome do privilégio para filtrar"
                            onChange={(e) => { setFilterPrivilegeText(e.target.value) }}
                        />
                    </Grid>
                    <Grid item xs={5} sm={5}>
                        <Box style={{ display: "flex", alignItems: "center", height: "100%" }}>
                            <TmpButtonCustom id="limpar-filtro" startIcon={<IconCancelar />} type="secondary" typeButton="button" size="sm" handleClick={handleClearFilter}>
                                Limpar
                            </TmpButtonCustom>
                            <TmpButtonCustom id="filtrar" startIcon={<IconPesquisar />} type="primary" typeButton="button" size="sm" handleClick={handleSearchPrivilege}>
                                Filtrar
                            </TmpButtonCustom>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <TmpTableBaseCustom
                            columns={headers}
                            showPagination={true}
                            itemsPerPage={20}
                            actionEditColumn={false}
                            actionDeleteColumn={true}
                            onDeleteClick={(e) => { props.onDeleteClick(e); handleSearchPrivilege(); }}
                            onEditClick={props.onEditClick}
                            rows={auxPrivilegeList}
                            rowsDeleted={props.ReRegistrationProfessionalPrivilegeForm.FormRemoveList}
                        />
                    </Grid>
                </Grid>
            </Grid>

            <Grid item xs={12}>

                <TmpTitleFormCustom marginTop={2}>
                    <Box display="flex" alignItems="center">
                        Cadastrar um novo privilégio <TooltipHtml title="Informação:" message="Você pode incluír novos prinvilégios ao seu cadastro." />
                    </Box>
                </TmpTitleFormCustom>

                <Grid container spacing={3}>
                    <Grid item xs={7} sm={7}>
                        <TmpInputSelectSearchAPICustom
                            label="Privilégio *"
                            name="Privilege"
                            id="Privilege"
                            placeholder="Pesquise pelo nome do privilégio"
                            disabled={props.ReRegistrationProfessionalPrivilegeForm.FormItemToEdit.Id > 0}
                            urlAPI="/sam/v1/professionalPrivilege/getAllPrivileges?textSearch="
                            value={props.ReRegistrationProfessionalPrivilegeForm.Privilege.Value}
                            onChange={(value: OptionItemTyped<Privilege>) => { props.onInputChange("Privilege", props.ReRegistrationProfessionalPrivilegeForm, value); props.onInputChange("Title", props.ReRegistrationProfessionalPrivilegeForm, value.Value?.Speciality); }}
                            onBlur={(value: OptionItemTyped<Privilege>) => { props.onInputChange("Privilege", props.ReRegistrationProfessionalPrivilegeForm, value); }}
                            error={props.ReRegistrationProfessionalPrivilegeForm.Privilege.HasError()}
                            helperText={props.ReRegistrationProfessionalPrivilegeForm.Privilege.Error}
                        />
                    </Grid>

                    <Grid item xs={5} sm={5}>
                        <TmpInputCustom
                            id="Title"
                            name="Title"
                            disabled={true}
                            label="Titulo *"
                            maxLength={80}
                            type="text"
                            placeholder="Selecione um privilégio"
                            value={props.ReRegistrationProfessionalPrivilegeForm.Title.Value}
                            onChange={(e) => {
                                props.onInputChange("Title", props.ReRegistrationProfessionalPrivilegeForm, e.target.value);
                            }}
                            onBlur={(e) => {
                                props.onInputChange("Title", props.ReRegistrationProfessionalPrivilegeForm, e.target.value);
                            }}
                            error={props.ReRegistrationProfessionalPrivilegeForm.Title.HasError()}
                            helperText={props.ReRegistrationProfessionalPrivilegeForm.Title.Error ?
                                props.ReRegistrationProfessionalPrivilegeForm.Title.Error :
                                (props.ReRegistrationProfessionalPrivilegeForm.Privilege.Value?.Id !== undefined ?
                                    `Sugestão: ${props.ReRegistrationProfessionalPrivilegeForm.Privilege.Value?.Value?.Speciality}` : "")
                            }
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <Box style={{ display: "flex", flexDirection: "row-reverse", alignItems: "flex-end", height: "100%" }}>

                            {(props.ReRegistrationProfessionalPrivilegeForm.FormItemToEdit.Id > 0 ?
                                <TmpButtonCustom id={"cancelar"} type="secondary" typeButton="button" size="sm" handleClick={props.onCancelItem}>
                                    Cancelar edição formação profissional
                                </TmpButtonCustom>
                                : null
                            )}

                            {(props.ReRegistrationProfessionalPrivilegeForm.FormItemToEdit.Id === 0 ?
                                <TmpButtonCustom id={"adicionar"} type="primary" typeButton="button" size="sm" handleClick={() => { props.onInserOrUpdateItem(); handleSearchPrivilege(); }}>
                                    Incluir privilégio
                                </TmpButtonCustom>
                                :
                                <TmpButtonCustom id={"adicionar"} type="primary" typeButton="button" size="sm" handleClick={props.onInserOrUpdateItem}>
                                    Salvar formação profissional
                                </TmpButtonCustom>
                            )}

                        </Box>
                    </Grid>
                </Grid>
            </Grid>
        </Grid >

    )

}